import axios from 'axios'

export default {
  namespaced: true,
  state: {
    websiteUsersObject: null,
    agencyUsersObject: null,
    websiteUserLandingsObject: null,
    agencyUserLandingsObject: null
  },
  mutations: {
    getUsersSuccess(state, { usersObject, role }) {
      if (role === 'AgencyUser') {
        state.agencyUsersObject = usersObject
      } else if (role === 'WebsiteUser') {
        state.websiteUsersObject = usersObject
      }
    },
    getUserLandingsSuccess(state, { userLandingsObject, role }) {
      if (role === 'AgencyUser') {
        state.agencyUserLandingsObject = userLandingsObject
      } else if (role === 'WebsiteUser') {
        state.websiteUserLandingsObject = userLandingsObject
      }
    },
    updateUserSuccess(state, singleUser) {
      const usersObject = singleUser.role === 'AgencyUser' ? state.agencyUsersObject : state.websiteUsersObject
      if (usersObject) {
        let indexFound = -1
        usersObject.data.every((item, index) => {
          if (item.id === singleUser.id) {
            indexFound = index
            return false
          }
          return true
        })
        if (indexFound > -1) {
          usersObject.data[indexFound] = singleUser
          usersObject.data.push({})
          usersObject.data.splice(usersObject.data.length - 1 , 1)
          if (singleUser.role === 'AgencyUser') {
            state.agencyUsersObject = usersObject
          } else if (singleUser.role === 'WebsiteUser') {
            state.websiteUsersObject = usersObject
          }
        }
      }
    },
    updateUserLandingSuccess(state, { userLanding, role }) {
      const userLandingsObject = role === 'AgencyUser' ? state.agencyUserLandingsObject : state.websiteUserLandingsObject
      if (userLandingsObject) {
        let indexFound = -1
        userLandingsObject.data.every((item, index) => {
          if (item.id === userLanding.id) {
            indexFound = index
            return false
          }
          return true
        })
        if (indexFound > -1) {
          userLandingsObject.data[indexFound] = userLanding
          userLandingsObject.data.push({})
          userLandingsObject.data.splice(userLandingsObject.data.length - 1 , 1)
          if (role === 'AgencyUser') {
            state.agencyUserLandingsObject = userLandingsObject
          } else if (role === 'WebsiteUser') {
            state.websiteUserLandingsObject = userLandingsObject
          }
        }
      }
    }
  },
  actions: {
    getUsers({ commit }, queries) {
      return new Promise((resolve, reject) => {
        axios
          .get('/users', { params: queries })
          .then((res) => {
            commit('getUsersSuccess', { usersObject: res.data, role: queries.role })
            resolve(res.data)
          })
          .catch((error) => reject(error))
      })
    },
    getUsersList({ commit }, queries) {
      return new Promise((resolve, reject) => {
        axios
          .get('/users/list', { params: queries })
          .then((res) => resolve(res.data.users))
          .catch((error) => reject(error))
      })
    },
    getCards({ commit }, queries) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/users/cards`, { params: queries })
          .then((res) => {
            resolve(res.data)
          })
          .catch((error) => reject(error))
      })
    },
    getCardTransfers({ commit }, queries) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/users/card-transfers-requests`, { params: queries })
          .then((res) => {
            resolve(res.data)
          })
          .catch((error) => reject(error))
      })
    },
    confirmCardTransfer({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/users/card-transfers-requests/${params.id}/confirm`, params)
          .then((res) => {
            resolve(res.data)
          })
          .catch((error) => reject(error))
      })
    },
    declineCardTransfer({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/users/card-transfers-requests/${params.id}/decline`)
          .then((res) => {
            resolve(res.data)
          })
          .catch((error) => reject(error))
      })
    },
    getUserLandings({ commit }, { userId, role, queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/users/${userId}/landings`, { params: queries })
          .then((res) => {
            commit('getUserLandingsSuccess', { userLandingsObject: res.data, role })
            resolve(res.data)
          })
          .catch((error) => reject(error))
      })
    },
    getUser({ commit }, userId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/users/${userId}`)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    createUser({ commit }, singleUser) {
      return new Promise((resolve, reject) => {
        axios
          .post('/users', singleUser)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updateUser({ commit }, singleUser) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/users/${singleUser.id}`, singleUser)
          .then((res) => {
            commit('updateUserSuccess', res.data.user)
            resolve(true)
          })
          .catch((error) => reject(error))
      })
    },
    updateUserLanding({ commit }, userLanding) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/user-landings/${userLanding.id}`, userLanding)
          .then((res) => {
            commit('updateUserSuccess', res.data.user)
            commit('updateUserLandingSuccess', {
              userLanding: res.data.userLanding,
              role: res.data.user.role
            })
            resolve(true)
          })
          .catch((error) => reject(error))
      })
    },
    changeUserPassword({ commit }, singleUser) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/users/${singleUser.id}/change-user-password`, singleUser)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    assignLandings({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/users/${params.userId}/landings`, params)
          .then((res) => resolve(res.data.user))
          .catch((error) => reject(error))
      })
    },
    assignExistingUsers({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landingId}/multiple-users`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteUser({ commit }, singleUser) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/users/${singleUser.id}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteUserLanding({ commit }, userLanding) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/user-landings/${userLanding.id}`)
          .then((res) => resolve(res.data.user))
          .catch((error) => reject(error))
      })
    },
  },
  getters: {
    websiteUsersObject: (state) => state.websiteUsersObject,
    agencyUsersObject: (state) => state.agencyUsersObject,
    agencyUserLandingsObject: (state) => state.agencyUserLandingsObject
  }
}